import React, { useState, useEffect }  from 'react';
import {Link} from "react-router-dom";
import { useNavigate} from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";
import {db} from '../../firebase'
import Navbar from "../inc/Navbar";
import PaginationOld from './PaginationOld';

import ScrollToTop from "react-scroll-to-top";

function Pinolex() {
    const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

    const [showPerPage, setShowPerPage] = useState(50);
    const [pagination, setPagination] =useState({
        start: 0,
        end: showPerPage,
    });

    const onPaginationChange = (start,  end) =>{
        setPagination({start: start, end: end});
    };
    const [searchTerm, setsearchTerm] = useState("");
    const [pinolex, setPinolex] = useState([])
    const navigate = useNavigate()

    const pinolexCollectionRef = collection(db, "pinolex");
    useEffect(() => {

        const getPinolex = async () => {
            const data = await getDocs(pinolexCollectionRef);
            setPinolex(data.docs.map((doc) => ({...doc.data(), id: doc.id })))
        }

        getPinolex()
    }, [])
    return (
        
<>

<Navbar/>

<ScrollToTop smooth top="100" color="dark"/>

<br/>
<br/>
<br/>
<br/>

<div className="album py-1">
        <div className="container mt-2">

            <div className="row">
            <nav aria-label="breadcrumb">
  <ol className="breadcrumb">
  <li className="breadcrumb-item"><Link to="/" href="#">HOME</Link></li>
    <li className="breadcrumb-item"><Link to="/Kajaria" >KAJARIA BEDROOM TILES</Link></li>
    <li className="breadcrumb-item"><Link to="/KajariaKitchenwall" >KAJARIA KITCHEN WALL TILES</Link></li>
    <li className="breadcrumb-item"><Link to="/Johnson" >JOHNSON</Link></li>
    <li className="breadcrumb-item"><Link to="/Orientbell" >ORIENTBELL</Link></li>
    <li className="breadcrumb-item"><Link to="/Jaquar" >JAQUAR</Link></li>
   
    <li className="breadcrumb-item"><Link to="/Somany" >SOMANY</Link></li>
    <li className="breadcrumb-item"><Link to="/Dulux" >DULUX</Link></li>
    <li className="breadcrumb-item"><Link to="/Coto" >COTO</Link></li>
    <li className="breadcrumb-item active" aria-current="page">FINOLEX PRODUCT</li>
  </ol>
</nav>
</div>
</div>
</div>
<div className="album py-1">
        
            <div className="container">

                <div className="row">
               
                <div className="col-md-6">
                        
                        <div className="card-body">
                        <input type="text" class="form-control" placeholder="Search" name="location" 
                        onChange ={(e) => {
                          setsearchTerm(e.target.value);
                        }}
                        />
                                <div className="d-flex justify-content-between align-items-center">
                                   
                                    
                            

                            </div>
                          
                    
                        </div>

                      
                    </div>
             
                    </div>
                  
                    </div>
                    </div>

<div className="album py-0">
        
        <div className="container">

            <div className="row">
            {pinolex.filter((val)=>{
      if (setsearchTerm === ""){
        return val;
      } else if (
        val.title.toLowerCase().includes(searchTerm.toLowerCase()) 
    

       
  
      ){
        return val;
      }
    }).slice(pagination.start, pagination.end).map((jaquar) => { return (
       
            <div className="col-md-4 mt-4">
                        <div className="card mb-4 border- box ">
                        <img  className="card-img-top" src={jaquar.img}   alt="eSSCO" />
                            <div className="card-body">
                                <center>
                                <h5 style={{color:"Gray"}} className="card-text mb-2"> <b> { jaquar.title} </b></h5>
                               
                                </center>


                         
                              
                                <div className="d-flex justify-content-between align-items-center">
                              
                                        

                                       
                                    
                              
                            </div>
                            </div>
                            </div>
                               
                            </div>
                                )})} 
                            </div>
                            <PaginationOld showPerPage={showPerPage} 
                onPaginationChange={onPaginationChange}
                total={pinolex.length}
                />
                            </div>
                            </div>
                            <br/>
                            
                           
</>

);
}

export default Pinolex;